// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"styles_buttonWrapper__24q4S","button":"styles_button__2L95j","cross":"styles_cross__2evuQ","icon":"styles_icon__1Rq3V"};